import { Modal } from 'antd';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';

const RulePage = ({ isModalRule, setIsModalRule }) => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleCancelRule = () => {
    setIsModalRule(false);
  };

  return (
    <Modal
      className="w-full max-w-[1000px] h-auto max-h-[850px] bg-white rounded-lg"
      title={
        <div style={{ textAlign: 'left', fontSize: '26px', color: '#0042CB' }}>
          DỰ ĐOÁN TỶ SỐ CÙNG 78Win
        </div>
      }
      open={isModalRule}
      footer={null}
      onCancel={handleCancelRule}
    >
      <div
        className="bg-white p-2 mt-4 md:pb-8 md:pt-4 md:px-10
                w-full"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
          }}
        />
      </div>
    </Modal>
  );
};

export default RulePage;
